export default __webpack_public_path__ + "static/media/cat-right-end.949b2b20.png";